<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">내부이미지</td>
                <td class="td_content text_center">
                    <div>
                        <div class="inline-block verti-middle" @click="changeType('mainImg')">
                            <el-upload
                                    class="avatar-uploader mr20"
                                    action=""
                                    list-type="picture"
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    :on-change="onlyOneFileUpload"
                            >
                                <img v-if="checkImg('mainImg')" :src="returnImg('mainImg')" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <button v-if="checkImg('mainImg')" class="cancelBtn"
                                        @click.stop="fileRemove(mainImg[0], [], 'mainImg')"></button>
                            </el-upload>
                        </div>
                        <div class="input_error mt5">{{ validation.firstError('mainImg') }}</div>
                    </div>
                </td>
                <td class="c_t_title">배경이미지</td>
                <td class="td_content text_center">
                    <div>
                        <div class="inline-block verti-middle" @click="changeType('backImg')">
                            <el-upload
                                    class="avatar-uploader mr20"
                                    action=""
                                    list-type="picture"
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    :on-change="onlyOneFileUpload"
                            >
                                <img v-if="checkImg('backImg')" :src="returnImg('backImg')" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <button v-if="checkImg('backImg')" class="cancelBtn"
                                        @click.stop="fileRemove(backImg[0], [], 'backImg')"></button>
                            </el-upload>
                        </div>
                        <div class="input_error mt5">{{ validation.firstError('backImg') }}</div>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">컬렉션명</td>
                <td colspan="3">
                    <div>
                        <el-input type="text" placeholder="컬렉션명" v-model="title" @input="parentChange('title',title)"
                                  class="shortest mr10"/>
                        <div class="input_error mt5">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">컬렉션소개</td>
                <td colspan="3">
                    <div>
                        {{ itemData.c_intro }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">컬렉션 소유자</td>
                <td colspan="3">
                    <div class="hover" @click="movePage(`/member/detail/${itemData.mb_no}`)">
                        {{ itemData.mb_nick }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">아이템수</td>
                <td colspan="3">
                    <div>
                        {{ itemData.item_cnt }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">아이템소유자수</td>
                <td colspan="3">
                    <div>
                        {{ itemData.owner_cnt }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">최저가</td>
                <td colspan="3">
                    <div>
                        {{ returnMinPrice(itemData) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">판매총액</td>
                <td colspan="3">
                    <div>
                        {{ itemData.c_total }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">좋아요수</td>
                <td colspan="3">
                    <div>
                        {{ itemData.Likes.cnt }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">양도가능여부</td>
                <td colspan="3">
                    <div>
                        {{ returnOwner(itemData) }}
                    </div>
                </td>
            </tr>
        </table>
        <div class="btn_box">
            <el-button class="reg_btn_out" v-if="itemData.mb_is_use !== 0" @click="writeItem()">저장</el-button>
            <el-button class="com_btn" @click="movePage()">목록</el-button>
        </div>
    </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import itemValidator from "@/mixins/validators/itemValidator";
import elFileMixins from "@/mixins/elFileMixins";

export default {
    name: "ItemWriteCollectionLayout",
    mixins: [imageOption, itemValidator, elFileMixins],
    components: {},
    inject: ['itemWriteSetData'],
    provide() {
        return {}
    },
    props: {
        itemData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            title: '',
            intro: '',
            owner: '',
            backImg: [],
            mainImg: [],

        }
    },
    beforeRouterEnter() {
    },
    created() {
        if (!util.isEmpty(this.itemData)) {
            this.initSetData()
        }
    },
    mounted() {
        EventBus.$on('ItemWriteCollectionLayoutValidator', this.checkValidator);
    },
    beforeUpdate() {

    },
    beforeDestroy() {
        EventBus.$off('ItemWriteCollectionLayoutValidator');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initSetData() {
            this.title = this.itemData.c_title;
            this.parentChange('title', this.title);
            this.intro = this.itemData.c_intro;
            this.parentChange('intro', this.intro);
            this.owner = this.itemData.c_owner;
            this.parentChange('owner', this.owner);
            if (!util.isEmpty(this.itemData.CollectionFiles)) {
                this.backImg = this.itemData.CollectionFiles.BgFile;
                this.parentChange('backImg', this.backImg);
                this.mainImg = this.itemData.CollectionFiles.MainFile;
                this.parentChange('mainImg', this.mainImg);
            }

        },
        writeItem() {
            EventBus.$emit('writeCollection')
        },

        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        parentChange(key, value) {
            this.itemWriteSetData(key, value)
        },
        checkData(data) {
            return !util.isEmpty(this[data]);
        },
        returnOwner(data) {
            if (data.c_owner === 1) {
                return '가능'
            }
            return '불가능'
        },
        returnMinPrice(data) {
            if (!util.isEmpty(data.min_price)) {
                return data.min_price
            }
            return 0
        },
        checkImg(typeName) {
            if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName])) {
                if (util.isEmpty(this[typeName][0].a_idx) && util.isEmpty(this[typeName][0].raw)) {
                    return false;
                }
                return true;
            }
        },
        returnImg(type) {
            if (!this.checkImg(type)) {
                return '';
            }
            return util.isEmpty(this[type][0].org_url) ? this[type][0].url : this[type][0].org_url
        },
        movePage() {
            this.$router.push(`/item/collection`);
        }
    },
    watch: {
        'itemData': {
            deep: true,
            handler: function (val, oldVal) {
                if (!util.isEmpty(this.itemData)) {
                    this.initSetData()
                }
            },
        }
    },
}
</script>

<style scoped>

</style>
